module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  })])]), _c('a', {
    attrs: {
      "href": "#/Introduction#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "requipment"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Equipment#equipment"
    }
  }, [_vm._v("Baking Equipment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "ringredient"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Ingredient#ingredient"
    }
  }, [_vm._v("Ingredient Tips and Substitutions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rstorage"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Storage#storage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storage and Freezing Tips")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast but Better")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot Cake Coffee Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip Monkey Bread Muffins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sconuts (aka Scone Doughnuts)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Muffin Waffles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overnight Pumpkin Cheesecake French Toast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candy Concoctions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candy Dipping Tips")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Meringue Pie Fudge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint Chip Truffles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesecake Chocolate Chip Cookie Dough Truffles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Cup Brownie Bites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip Cookie Toffee Bark")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar Cookie Dough Cups")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies, Brownies, and Bars Together at Last!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’more Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truffle-Topped Brownies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cake Batter Blondie Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Brookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rocky Road Cookie Fudge Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Roll Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pie Surprise")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-Butter Pie Crust")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch20"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip Cookie Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch21"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies ’n’ Cream Magic Bar Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch22"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milky Way Brownie Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch23"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elvis Hand Pies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch24"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turtle Pudding Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart5"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part05#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cake & Cupcake Creations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch25"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Cookie Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch26"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carrot Cake Cheesecake Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch27"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death by Chocolate Brownie Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch28"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Pie Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch29"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snickers Cake Roll")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch30"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’morescake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part06#part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Takes on Cheesecake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch31"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesecake Swirl Brownie Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch32"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies ’n’ Cream Cheesecake Ice Cream")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch33"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Cookie Cheesecake Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch34"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Cheesecake Sandwich Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch35"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Bar Cheesecake")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart7"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part07#part7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Double Dips")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch36"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pie Crust Dippers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch37"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oreo Peanut Butter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch38"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tiramisu Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch39"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Cookie Fondue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch40"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almond Joy Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch41"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Cream Pie Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart8"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Part08#part8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Mash-Ups")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch42"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Covered Strawberry Truffles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch43"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rainbow Sugar Cookie Pizza")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch44"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Cheesecake Football Dip")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch45"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Chocolate Coconut Pie Fudge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch46"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Pie Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch47"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Payday Candy Corn Rice Krispies Treats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch48"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter48#ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pecan Pie Cinnamon Rolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch49"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter49#ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Cheesecake Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch50"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter50#ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Spice Cake Blondies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch51"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter51#ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Pie Magic Bars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b",
    attrs: {
      "id": "rch52"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Chapter52#ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brownie Peppermint Bark")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "requivalents"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Measurement#equivalents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measurement and Pan-Size Equivalents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rauthor"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Author#author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0